// extracted by mini-css-extract-plugin
export default {"error":"conditional-issue-text_error__3n1Sr","warning":"conditional-issue-text_warning__2M2cu","errorWrapper":"conditional-issue-text_errorWrapper__3eYEa"};